import { FC, useState } from 'react';

import { useNotification } from 'hooks';
import { Auth } from 'utils';

import {
  Button,
  Form,
  FormattedMessage,
  Modal,
  Row,
  Space,
  notification,
} from 'components';

import { NewPassword } from './components';

interface ModalProps {
  open: boolean;
  onCancel(): void;
}

const ChangePasswordModal: FC<ModalProps> = ({ open, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, toggleLoading] = useState(false);
  const showNotification = useNotification();

  const onSubmit = async (values: {
    oldPassword: string;
    newPassword: string;
  }) => {
    toggleLoading(true);

    try {
      await Auth.updatePassword(values);

      showNotification({
        type: 'success',
        message: 'messages.success',
      });

      onCancel();
    } catch (e: any) {
      notification.error({
        message: e.message,
      });
    }

    toggleLoading(false);
  };

  return (
    <Modal
      title='Change Password'
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <p>
        Please enter your current password.
        <br />
        <br />
        You should also enter a new password (and confirm it) in the fields
        below.
        <br />
      </p>
      <Form
        form={form}
        name='changePassword'
        layout='vertical'
        onFinish={onSubmit}
        preserve={false}
      >
        <NewPassword />
        <Row align='bottom' justify='end'>
          <Space>
            <Button type='default'>
              <FormattedMessage id='button.cancel' />
            </Button>
            <Button type='primary' htmlType='submit' loading={loading}>
              <FormattedMessage id='button.ok' />
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
